import { Colors } from './Colors';

export const Tooltip = (theme) => ({
    MuiTooltip: {
      ...theme.components.MuiTooltip,
      defaultProps: {
        arrow: true,
        placement: "top",
        enterTouchDelay: 1, // makes tooltips "touchable" for mobile devices
      },
      styleOverrides: {
        tooltip: {
          padding: '10px 15px',
          fontSize: '13px',
          color: Colors.white,
          lineHeight: '16px',
        },
      }
    },
});